<template>
	<div class="view-search" @click="user_menu_visible = false">

		<div class="search-bar">
			<div class="back" @click="back()">
				<icon file="arrow-left" :size="32"/>
			</div>

			<filters />
			<!-- <div class="input-search">
				<input
					type="text"
					class="input"
					v-model="query_string"
					placeholder="Rechercher une étude"
					@keypress.enter="launch_search()"
				>
				<button class="button" @click="launch_search()">
					<icon file="arrow-right" :size="25"/>
				</button>
			</div> -->
		</div>

		<search />

		<!-- <transition name="slide">
			<etude v-if="active_study"/>
		</transition> -->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Filters from '@/components/search/filters'
import Search from "@/components/search"
import Etude from "@/components/etude"

export default {
	name: "view-search",
	data: function() {
		return {
			user_menu_visible: false
		};
	},
	mounted(){
		this.$store.dispatch("load_projects_v2", { initial_search: true })
	},
	computed: {
		// mix the getters into computed with object spread operator
		...mapGetters(["mode", "active_study", "query", "user_profile", "user_name"]),
		query_string: {
			get() {
				return this.query;
			},
			set(newValue) {
				return this.$store.dispatch("set_query", { query: newValue });
			},
		},
		user_initials() {
			if (!!this.user_profile.firstname) {
				return `${this.user_profile.firstname[0]}${this.user_profile.lastname[0]}`;
			}
			return '';
		}
	},
	methods: {
		back: function() {
			this.$store.dispatch("remove_all_filters");
			this.$router.push({ name: 'home' })
		},
		// launch_search: function() {
		// 	this.$store.dispatch("load_projects");
		// },
	},
	components: { Search, Etude, Filters }
};
</script>

<style lang="stylus">
@import '../assets/css/app';

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.slide-enter, .slide-leave-to {
	transform: translateX(100%);
}

.view-search {
	height: 100%;

	.header {
		position: absolute;
		left: 0;
		top: -(104px + 80px);
		right: 0;
		text-align: center;
		height: 104px + 80px;
		transition: 0.25s easeOutQuart;

		.content {
			padding: 32px 0;

			.logo {
				display: block;
				margin: 0 auto;
				width: 294px;
				height: auto;
			}

			.main-title {
				position: absolute;
				left: 50%;
				bottom: 0px;
				padding-right: 142px + 4px;
				transform: translate(-50%);
				height: 16px;
				font-weight: 500;
				font-size: 1.8rem;
				line-height: 16px;
				font-weight: 400;
				// text-transform uppercase
				color: #3e5d58;

				// background blue
				.adequation {
					position: absolute;
					right: 0;
					bottom: -5px;
					display: inline-block;
					height: 30px;
					width: 142px;

					svg {
						display: block;
						height: 100%;
						width: auto;
					}
				}
			}
		}

		.user {
			position: absolute;
			right: 16px;
			top: 16px;
			white-space: nowrap;

			.user-name {
				line-height: 32px;
				cursor: pointer;
				color: #999;

				&:hover {
					color: #666;
				}

				.initale {
					float: left;
					width: 32px;
					height: 32px;
					margin: 0 8px 0 0;
					border-radius: 100%;
					background-color: red;
					color: #fff;
					font-weight: 500;
				}
			}

			.user-menu {
				position: absolute;
				right: 0;
				min-width: 150px;
				top: 40px;
				background: #eee;
				padding: 8px 0;
				border-radius: radius;

				&:before {
					content: '';
					position: absolute;
					left: 50%;
					top: -8px;
					margin-left: -8px;
					width: 0;
					height: 0;
					border-style: solid;
					border-width: 0 8px 8px 8px;
					border-color: transparent transparent #eee transparent;
				}

				.action {
					line-height: 32px;
					padding: 0 16px;
					cursor: pointer;
					text-align: left;

					&:hover {
						background-color: red;
						color: #fff;
					}
				}
			}
		}
	}

	.search-bar {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		background-color: red;
		height: 80px + 40px;
		text-align: center;
		padding: ((@height - 56px) / 2) 0;
		transition: 0.25s easeOutQuart;
		z-index 1001
		.back {
			position: absolute;
			left: 24px;
			top: 44px;
			color: #fff;
			cursor: pointer;
			z-index:2;
		}

		.input-search {
			display: inline-block;
			width: 400px;
			height: 56px;
			background-color: #fff;
			border-radius: @height;

			.input {
				display: block;
				height: @height;
				width: 100%;
				padding: 0 56px 0 32px;
				border: none;
				background: transparent;
				outline: none;
				font: inherit;
				font-size: 1.7rem;
				color: inherit;
			}

			.button {
				position: absolute;
				width: @height;
				height: @height;
				right: 0;
				top: 0;
				border: none;
				background: transparent;
				cursor: pointer;
				outline: none;
				border-radius: 100%;
				font: inherit;
				color: #999;

				&:hover, &:focus {
					color: red;
				}
			}
		}
	}
	
	.search {
		top: 120px;
	}
}
</style>
